<template>
    <div
        class="performance"
        :class="event.tessitura?.keywords?.length && 'performance--tags'"
    >
        <div class="performance-availability">
            <div
                v-if="event.availability" v-cloak
                class="performance-availability__container"
                :class="`performance-availability--${event.availability_level_handle}`"
                :aria-label="`${event.availability_level} availability`"
            >
                <div class="performance-availability__icon" aria-hidden="true">
                    <div class="performance-availability__wrapper">
                        <div class="performance-availability__inner">
                            <svg class="performance-availability__circle">
                                <circle class="performance-availability__circle--bg" cx="57" cy="57" r="50" />
                                <circle class="performance-availability__circle--meter" cx="57" cy="57" r="50" />
                            </svg>
                        </div>
                    </div>

                    <svg class="event-availability__chair" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 13.884 20">
                        <path d="M1.713,11.755h.941V7.969H2.485A1.16,1.16,0,0,1,1.328,6.812V1.157A1.16,1.16,0,0,1,2.485,0H11.4a1.16,1.16,0,0,1,1.157,1.157V6.812A1.163,1.163,0,0,1,11.4,7.969h-.17v3.77h1.1a1.557,1.557,0,0,1,1.554,1.555v1.52a.419.419,0,0,1-.419.419h-.908v4.349a.419.419,0,1,1-.838,0V15.232H2.165v4.349a.419.419,0,1,1-.838,0V15.232H.419A.419.419,0,0,1,0,14.813V13.467a1.716,1.716,0,0,1,1.713-1.712Zm8.679-2.322V7.969h-6.9v3.786h6.9V10.271" transform="translate(0 0)"/>
                    </svg>

                    <span class="event-availability__text"><span class="visually-hidden">Availability: </span>{{event.availability_level}}</span>
                </div>
            </div>
        </div>

        <div class="performance__date-time">
            <span class="performance__date">{{ formatDate(event.performancedate, 'EEEE') }} {{ formatDate(event.performancedate, 'MMMM') }} {{ formatDate(event.performancedate, 'd') }}</span>
            <span class="performance__time"><span class="performance__at"> at </span>{{ formatTime(event.performancedate) }}</span>
        </div>
        <ul class="performance__tags" v-if="event.attributes?.custom?.tags">
            <li class="tag" v-for="(keyword, index) in event.attributes.custom?.tags" :key="index">
                {{keyword}}
            </li>
        </ul>

        <div class="performance__action">
            <a v-if="event.is_bookable" class="performance__btn btn" :href="event.tickets_url">{{ event.availability_override || 'Buy tickets' }}</a>
            <span v-else class="performance__btn performance__btn--unavailable btn" :href="event.tickets_url">{{ event.availability_level }}</span>
        </div>

        <div v-if="event.attributes?.custom?.post_show_panel" class="performance__panel">
            <strong>Post show panel:</strong> {{event.attributes?.custom?.post_show_panel}}
        </div>


        <!-- <div v-if="event.filters?.categories" class="ticket-list-event__footer">
            <calendar-info :event="event"/>
        </div> -->
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';
import { format } from 'date-fns';
import CalendarInfo from './calendar-info.vue';

export default defineComponent({
    name: 'TicketListEvent',
    components: { CalendarInfo },
    props: {
        event: {
            type: Object,
            required: true,
        }
    },
    setup(props) {
        const dialog = ref(null);

        const getImageURL = (url, width, height) => {
            return url + '?w=' + width + '&h=' + height;
        }

        const formatTime = (date) => {
            if (!date) return ''
            const d = new Date(date)
            let hours = d.getHours()
            const minutes = d.getMinutes()
            const ampm = hours >= 12 ? 'pm' : 'am'
            hours = hours % 12
            hours = hours ? hours : 12 // the hour '0' should be '12'
            const minutesStr = minutes < 10 ? '0' + minutes : minutes
            return `${hours}:${minutesStr}${ampm}`
        }

        const formatDate = (date, formatStr) => {
            const dateObj = typeof date === 'string' ? new Date(date) : date;
            return format(dateObj, formatStr);
        };

        onMounted(() => {
            console.log('props.event');
            console.log(props.event.attributes);
            dialog.value = document.getElementById('calendar-popup');
        });

        return {
            formatTime,
            formatDate,
            getImageURL,
        };
    },
});
</script>
